import { completeSsoLogin, getPermissions, handleSaleRepLogin, impersonateUser, newTechpackEditorUrl, redirectToNewDashboard, setPageTitle, shouldUseInAppDashboard } from "@/helpers/Helpers";
import { clearImpersonation, exitImpersonation } from "@/helpers/impersonation";
import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';


// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/NewDashboard')
const NotFound = () => import('@/views/pages/Page404')
const Login = () => import('@/views/pages/Login')
const Forbidden = () => import('@/views/pages/Forbidden')
const ForgotPassword = () => import('@/views/pages/ForgotPassword')

const ResetPassword = () => import('@/views/pages/ResetPassword')

const Register = () => import('@/views/pages/Register')
const Products = () => import('@/views/products/Listing')
const AddProduct = () => import('@/views/products/Add')
const EditCompanyProduct = () => import('@/views/products/EditCompanyProduct')
const Factories = () => import('@/views/factories/Listing')
const sku = () => import('@/views/sku/Listing')
const EmailTemplate = () => import('@/views/email-templates/Listing')
const Steps = () => import('@/views/steps/Listing')
const Categories = () => import('@/views/categories/Listing')
const DataSource = () => import('@/views/datasource/Listing')
const CustomFonts = () => import('@/views/custom-fonts/Listing')
const Permissions = () => import('@/views/authorization/permissions')
const Roles = () => import('@/views/authorization/roles')
const User = () => import('@/views/authorization/user')
const Settings = () => import('@/views/authorization/assignpermissions')

const EmailConfiguration = () => import('@/views/settings/EmailConfiguration')
const GeneralSettings = () => import('@/views/settings/GeneralSettings')
const UIBranding = () => import('@/views/settings/UIBranding')
const Container = () => import('@/views/container/Listing');
const Sizes = () => import('@/views/products/Sizes');
const ViewProductDesign = () => import('@/views/container/ViewProductDesign')
const Customers = () => import('@/views/authorization/customers')
const Cuttings = () => import('@/views/cuttings/Listing')
const OrderListing = () => import('@/views/order/OrderListing')
const OrderView = () => import('@/views/order/view')
const OrderDetail = () => import('@/views/order/OrderDetail')
const CondensendPdfView = () => import('@/views/order/CondensendPdfView')

const YearlyPlannerTemplates = () => import('@/views/yearly-planner-templates/Listing')
const YearlyPlannerEvents = () => import('@/views/yearly-planner-events/Listing')
const VideoTemplates = () => import('@/views/video-templates/Listing')
const DefaultVideoTemplates = () => import('@/views/default-video-templates/Listing')
const VideoUsage = () => import('@/views/video-usage/Listing')
const Translations = () => import('@/views/translations/Listing');
const Companies = () => import('@/views/companies');
const GeneralAction = () => import('@/views/GeneralAction.vue');


const PriceList = () => import('@/views/price-list/Listing.vue')
const DesignCategories = () => import('@/views/design-categories/Listing.vue')
const DefaultProducts = () => import('@/views/default-products')
const EditDefaultProducts = () => import('@/views/default-products/Edit.vue')

const Brands = () => import('@/views/brand/Listing.vue')

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
});


function configRoutes() {
  return [
    {
      path: '/order/:order_id/condensend-pdf',
      component: CondensendPdfView
    },
    //todo need to remove this after confirmation, as redirection applied here while the component is also introduced
    {
      path: '/',
      redirect: { name: 'Dashboard' },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/login',
      redirect: '/login',
      name: 'Home',
      component: Login,
      children: [
        {
          path: '/login',
          name: 'Login',
        }
      ]
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
      ]
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'products',
          name: 'products',
          component: Products
        },
        {
          path: 'products/add',
          name: 'add-product',
          component: AddProduct
        },
        {
          path: 'products/update/:id',
          name: 'edit-product',
          component: AddProduct
        },
        {
          path: 'products/update-company-fields/:id',
          name: 'edit-company-product',
          component: EditCompanyProduct,
          props: true
        },
        {
          path: 'products/steps',
          name: 'add-steps',
          component: Steps
        },
        {
          path: 'products/categories',
          name: 'categories',
          component: Categories
        },
        {
          path: 'products/data-source',
          name: 'data-source',
          component: DataSource
        },
        {
          path: 'products/custom-fonts',
          name: 'custom-fonts',
          component: CustomFonts
        },
        {
          path: 'container',
          name: 'container',
          component: Container
        },
        {
          path: 'product-designs/:id/view',
          name: 'ViewProductDesign',
          component: ViewProductDesign
        },
        {
          path: 'roaster-sizes',
          name: 'roaster-sizes',
          component: Sizes
        },
        {
          path: 'factory-cuttings',
          name: 'factory-cuttings',
          component: Cuttings
        },
        {
          path: 'translations',
          name: 'translations',
          component: Translations
        },
        {
          path: 'price-list',
          name: 'price-list',
          component: PriceList
        },
        {
          path: 'design-categories',
          name: 'design-categories',
          component: DesignCategories
        },

//Frobidden Route
        {
          path: '/unauthorized',
          name: 'Unauthorized',
          component: Forbidden,
        },
      ]
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'factories',
          name: 'factories',
          component: Factories
        },
        {
          path: 'sku',
          name: 'sku',
          component: sku
        },
        {
          path: 'brands',
          name: 'brands',
          component: Brands
        }
      ]
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'email-configuration',
          name: 'email-configuration',
          component: EmailConfiguration
        },
        {
          path: 'general-settings',
          name: 'general-settings',
          component: GeneralSettings
        },
        {
          path: 'ui-branding',
          name: 'ui-branding',
          component: UIBranding
        },
        {
          path: 'email-templates',
          name: 'email-templates',
          component: EmailTemplate
        },
        {
          path: 'yearly-planner-events/:id/view',
          name: 'YearlyPlannerEvents',
          component: YearlyPlannerEvents,
          props: { templateName: 'sdfa' }
        },
        {
          path: 'yearly-planner-templates',
          name: 'YearlyPlannerTemplates',
          component: YearlyPlannerTemplates
        },
        {
          path: 'default-video-templates',
          name: 'DefaultVideoTemplates',
          component: DefaultVideoTemplates
        },
        {
          path: 'video-templates',
          name: 'VideoTemplates',
          component: VideoTemplates
        },
        {
          path: 'video-usage',
          name: 'VideoUsage',
          component: VideoUsage
        }

      ]
    },
    {
      // The classic tech pack editor was taken down on 16 Oct 2026 (announced
      // to everyone). A direct link here lands on the V2 editor with the
      // session handed over; nothing on this origin renders it any more.
      path: '/edit-techpack/:order_id',
      name: 'EditTechpak',
      beforeEnter: (to, from, next) => {
        window.location.replace(newTechpackEditorUrl(to.params.order_id));
        next(false);
      }
    },
    {
      path: '/',
      name: '',
      component: TheContainer,
      children: [
        {
          path: 'permissions',
          name: 'permissions',
          component: Permissions
        },
        {
          path: 'roles',
          name: 'roles',
          component: Roles
        },
        {
          path: 'users',
          name: 'users',
          component: User
        },
        {
          path: 'role/permissions/:id/update',
          name: 'assignpermissions',
          component: Settings
        },
        {
          path: 'customers',
          name: 'customers',
          component: Customers
        },
        {
          path: 'orders',
          name: 'orders',
          component: OrderListing
        },
        {
          path: '/order/:order_id/detail',
          name: 'OrderDetail',
          component: OrderDetail
        },
        {
          path: 'order/:order_item_id/:factory_product_id',
          name: 'order-view',
          component: OrderView
        },
        {
          path: 'companies',
          name: 'companies',
          component: Companies
        },
        {
          path: 'general-action',
          name: 'general-action',
          component: GeneralAction
        },
        {
          path: 'default-products',
          name: 'default-products',
          component: DefaultProducts
        },
        {
          path: 'products/update-default-product/:id',
          name: 'edit-default-products',
          component: EditDefaultProducts,
          props: true
        },
      ]
    },
    {
      path: '/*',
      redirect: '/dashboard',
    },
    {
      path: '/error',
      name: 'notfound',
      component: NotFound
    },

  ]
}

router.beforeEach(async (to, from, next) => {
  setPageTitle()

  const authToken = to.query.auth_token;
  const forceLogout = to.path === '/login' && String(to.query.logout || '') === '1';

  // Microsoft SSO handoff lands HERE (?sso=1&access_token=...), not on the new
  // dashboard, so this origin holds the admin session that impersonation needs.
  // Establish the full session here, then forward to the new dashboard — the same
  // two hops a password login makes.
  if (String(to.query.sso || '') === '1' && to.query.access_token) {
    try {
      const forwarded = await completeSsoLogin(
        String(to.query.access_token),
        to.query.refresh_token ? String(to.query.refresh_token) : null
      );
      if (forwarded) {
        return; // completeSsoLogin/setAuthUserData is redirecting to the new dashboard
      }
      return next({ name: 'Dashboard' });
    } catch (e) {
      return next({ path: '/login', query: { sso_error: 'sso_failed' } });
    }
  }

  // "Exit impersonation" requested from the new dashboard (Vega). The original
  // session stash lives in THIS origin's localStorage, so restore it here.
  // exitImpersonation() does a full page load to '/'; the restored admin is
  // then bounced back to Vega by the normal access-new-dashboard redirect.
  if (String(to.query.exit_impersonation || '') === '1') {
    exitImpersonation();
    return;
  }

  // Explicit logout handoff from admin-v2 -> legacy admin login.
  // Clear local legacy auth before any auto-redirect checks.
  if (forceLogout) {
    localStorage.removeItem('user');
    localStorage.removeItem('company');
    localStorage.removeItem('role');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    clearImpersonation();
    store.commit('SET_AUTH_USER', null);
    store.commit('SET_AUTH_ROLE', null);
    store.commit('AUTH_SUCCESS', null);
    await store.dispatch("setAuthPermissions", []);
    return next({
      path: '/login',
      query: {},
      replace: true
    });
  }

  // "Login as user" requested from the new dashboard (Vega). Impersonation has to
  // start on THIS origin — this is where login lives and where the stash that
  // "Exit impersonation" restores is kept — so Vega hands the user id over rather
  // than swapping a token it cannot exit from. impersonateUser() redirects on
  // success; on failure the admin stays signed in and lands on the dashboard
  // instead of an endless ?impersonate= URL (AB#21160).
  const impersonateId = String(to.query.impersonate || '');
  if (/^\d+$/.test(impersonateId)) {
    if (store.getters.isAuthenticated) {
      const started = await impersonateUser(impersonateId);
      if (started) {
        return;
      }
      return next({ name: 'Dashboard' });
    }
    // Not signed in here: the login page owns that, and the request dies with it
    // rather than being replayed after an unrelated sign-in.
    return next({ path: '/login' });
  }

  // redirect unauthenticated user to login page if trying to access a restricted page
  const publicPages = ['/login', '/forgot-password', '/reset-password'];
  const authRequired = !publicPages.includes(to.path);
  // const loggedIn = localStorage.getItem('access_token');
  if (authRequired && !store.getters.isAuthenticated) {
    if (authToken) {
      const { auth_token, ...restOfQuery } = to.query;
      const queryString = new URLSearchParams(restOfQuery).toString();
      const redirect_url = `${window.location.origin}${to.path}${queryString ? `?${queryString}` : ''}`;
      handleSaleRepLogin(to.params.order_id, authToken, redirect_url)
    } else {
      return next({
        path: '/login',
      });
    }

  } else {
    if (store.getters.isAuthenticated) {
      if (authToken) {
        const { auth_token, ...restOfQuery } = to.query;
        const queryString = new URLSearchParams(restOfQuery).toString();
        const redirect_url = `${window.location.origin}${to.path}${queryString ? `?${queryString}` : ''}`;
        handleSaleRepLogin(to.params.order_id, authToken, redirect_url)
      } else {
        await getPermissions()
        if (to.name === 'Dashboard' && !shouldUseInAppDashboard() && redirectToNewDashboard()) {
          return;
        }
      }

    }
    if (!authToken) {
      if (to.path === '/login' && store.getters.isAuthenticated) {
        if (to.query.redirect === 'products') {
          return next({
            path: '/products', query: { 'sync': to.query.sync, 'post_id': to.query.post_id }
          });
        } else {
          return next({ name: 'Dashboard' })
        }
      } else if (to.path === '/general-action' && store.getters.roleName !== 'superadmin') { // only superadmin can access general-action
        return next({ name: 'Dashboard' })
      }
      next();
    }
  }
})

export default router;
